import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate';

const currentLocale = document.documentElement.lang;
(async () => {
    const messages = await (async () => {
        try {
            return await import(`vee-validate/dist/locale/${currentLocale}`);
        } catch (e) {
            return await import(`vee-validate/dist/locale/en`);
        }
    })();
    Validator.localize(currentLocale, messages);
})();

Validator.extend('variant-rule-action', (action) => {
    return [
        action.fillColor, action.strokeColor,
        action.textColor, action.image
    ].some(v => !!v);
});

Vue.use(VeeValidate);
